export const selectBoardSearch = state => state.search.search;
